import { InjectionToken, Type } from '@angular/core';
import { NotificationLoyaltyType } from '@fgb/core';

export type AlertNotificationComponentMap = Record<NotificationLoyaltyType, Type<any> | undefined>;

export const ALERT_NOTIFICATION_COMPONENTS = new InjectionToken<AlertNotificationComponentMap>('ALERT_NOTIFICATION_COMPONENTS', {
  providedIn: 'root',
  factory: () => DefaultComponentMap,
});

export function mergeAlertNotificationComponentMaps(
  partialOverride: Partial<AlertNotificationComponentMap>
): AlertNotificationComponentMap {
  return { ...DefaultComponentMap, ...partialOverride };
}

const DefaultComponentMap: AlertNotificationComponentMap = {
  [NotificationLoyaltyType.None]: undefined,
  [NotificationLoyaltyType.AuctionOutBid]: undefined,
  [NotificationLoyaltyType.MarketplaceOrderProcessed]: undefined,
  [NotificationLoyaltyType.VoucherCodeEntered]: undefined,
  [NotificationLoyaltyType.ScorecardComplete]: undefined,
  [NotificationLoyaltyType.PointsNotification]: undefined,
  [NotificationLoyaltyType.EcashSpend]: undefined,
  [NotificationLoyaltyType.AttendanceCheckIn]: undefined,
  [NotificationLoyaltyType.AnswerTrivia]: undefined,
  [NotificationLoyaltyType.LottoWon]: undefined,
  [NotificationLoyaltyType.AuctionWon]: undefined,
  [NotificationLoyaltyType.AuctionBidPlaced]: undefined,
  [NotificationLoyaltyType.ScorecardActionComplete]: undefined,
  [NotificationLoyaltyType.ScorecardMilestoneComplete]: undefined,
  [NotificationLoyaltyType.CampaignManagerNotification]: undefined,
  [NotificationLoyaltyType.ScorecardExpirationNotification]: undefined,
  [NotificationLoyaltyType.ScorecardActivationNotification]: undefined,
};
